import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetDemoOrgMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ResetDemoOrgMutation = { __typename?: 'Mutation', resetDemoOrg: { __typename?: 'BaseMutationResult', success: boolean } };


export const ResetDemoOrgDocument = gql`
    mutation resetDemoOrg {
  resetDemoOrg {
    success
  }
}
    `;
export type ResetDemoOrgMutationFn = Apollo.MutationFunction<ResetDemoOrgMutation, ResetDemoOrgMutationVariables>;

/**
 * __useResetDemoOrgMutation__
 *
 * To run a mutation, you first call `useResetDemoOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetDemoOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetDemoOrgMutation, { data, loading, error }] = useResetDemoOrgMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetDemoOrgMutation(baseOptions?: Apollo.MutationHookOptions<ResetDemoOrgMutation, ResetDemoOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetDemoOrgMutation, ResetDemoOrgMutationVariables>(ResetDemoOrgDocument, options);
      }
export type ResetDemoOrgMutationHookResult = ReturnType<typeof useResetDemoOrgMutation>;
export type ResetDemoOrgMutationResult = Apollo.MutationResult<ResetDemoOrgMutation>;
export type ResetDemoOrgMutationOptions = Apollo.BaseMutationOptions<ResetDemoOrgMutation, ResetDemoOrgMutationVariables>;